import * as Yup from 'yup';

export const requiredRule = {
  message: 'Обязательное поле'
};

export const notEmptyRule = {
  message: 'Поле не может быть пустым'
};

export const emailRule = {
  message: 'Некорректный формат'
};

export const phoneRule = {
  message: 'Некорректный номер',
  regex:
    /^(8|\+?7)(([\- ])?\(?(\d{3})\)?)[\- ]?([\d]{7}|\d{3}[\- ]\d{2}[\- ]\d{2}|\d{2}[\- ]\d{2}[\- ]\d{3}|\d{3}[\- ]\d{4})$/
};

export const nameRule = {
  message: 'Некорректный формат',
  regex: /^([ a-zа-яё\-\']+){1,}$/i
};

export const feedbackFormValidationSchema = Yup.object().shape({
  name: Yup.string().required(requiredRule.message).matches(nameRule.regex, {
    message: nameRule.message
  }),
  phone: Yup.string().required(requiredRule.message).matches(phoneRule.regex, {
    message: phoneRule.message
  }),
  policy: Yup.boolean().oneOf([true], requiredRule.message)
});

export const feedbackFormPostValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required(requiredRule.message)
    .max(200)
    .matches(nameRule.regex, {
      message: nameRule.message
    }),
  phone: Yup.string()
    .required(requiredRule.message)
    .max(30)
    .matches(phoneRule.regex, {
      message: phoneRule.message
    }),
  comment: Yup.string().max(2000).optional(),
  subject: Yup.string().max(300).optional(),
  mailing: Yup.boolean().optional()
});

export enum LogItemStatus {
  Error = 'error',
  Warning = 'warning',
  Info = 'info'
}

export const logItemValidationSchema = Yup.object().shape({
  status: Yup.string()
    .required(requiredRule.message)
    .oneOf(Object.values(LogItemStatus)),
  message: Yup.string().required(requiredRule.message).trim().max(10000)
});
